import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  ListSubheader,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { getTimezoneOptionsByRegion } from 'helper/time';

interface ControlledTimezoneSelectProps {
  name: string;
  control: any;
  label?: string;
  required?: boolean;
  error?: any;
  helperText?: string;
}

export const ControlledTimezoneSelect: React.FC<ControlledTimezoneSelectProps> = ({
  name,
  control,
  label = 'Timezone',
  required = false,
  error,
  helperText,
}) => {
  const hasError = Boolean(error);
  const timezonesByRegion = getTimezoneOptionsByRegion();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required ? `${label} is required` : false }}
      render={({ field }) => (
        <FormControl 
          fullWidth 
          error={hasError}
          required={required}
        >
          <InputLabel>{label}</InputLabel>
          <Select
            {...field}
            label={label}
            displayEmpty
          >
            {Object.entries(timezonesByRegion).map(([region, timezones]) => [
              <ListSubheader key={region} sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                {region}
              </ListSubheader>,
              ...timezones.map((timezone) => (
                <MenuItem key={timezone.value} value={timezone.value}>
                  {timezone.label}
                </MenuItem>
              ))
            ])}
          </Select>
          {(hasError || helperText) && (
            <FormHelperText>
              {hasError ? error?.message : helperText}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default ControlledTimezoneSelect;